import { render, staticRenderFns } from "./PLT.vue?vue&type=template&id=4b8aefe1&scoped=true"
import script from "./PLT.vue?vue&type=script&lang=js"
export * from "./PLT.vue?vue&type=script&lang=js"
import style0 from "./PLT.vue?vue&type=style&index=0&id=4b8aefe1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8aefe1",
  null
  
)

export default component.exports